import { NgModule } from "@angular/core";
import { UsageCounterComponent } from "./usage-counter.component";
import { CommonModule } from '@angular/common';
import { DirectivesModule } from "app/directives/directives.module";

@NgModule({
    declarations: [
        UsageCounterComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule
    ],
    exports: [
        UsageCounterComponent
    ]
})
export class UsageCounterModule {}
